import { KuposCheckbox, KuposModal, SvgHome } from '../common';
import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import PropTypes from 'prop-types';
import { TermsAndConditions } from '../pages';

export default class PassengerDetailsBlock extends Component {
  static propTypes = {
    ticketDetails: PropTypes.object,
    selectedSeats: PropTypes.object,
    onSeatCheck: PropTypes.func,
    t: PropTypes.func,
    selectAll: PropTypes.func,
    allSelected: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      tncChecked: false,
    };
  }

  showCheckAll = () => {
    if (this.props.ticketDetails) {
      for (let key in this.props.ticketDetails.seat_Details.seat_details) {
        if (this.props.ticketDetails.seat_Details.seat_details[key].cancel_status === 0)
          return true;
      }
    } else {
      return true;
    }
    return false;
  };

  renderPassengerSeats = () => {
    const { ticketDetails, isOfflineCancel } = this.props;
    return (
      <div className="passenger-seat-rows-block">
        <div className="right-card-sections bold-text font10">
          <span>
            {this.showCheckAll() ? (
              <KuposCheckbox
                onChange={() => this.props.selectAll()}
                checked={this.props.allSelected}
              />
            ) : null}
          </span>
          <span>{this.props.t('CANCEL_TICKET.SEAT_NUMBER')}</span>
          <span>{this.props.t('CANCEL_TICKET.PASSENGER')}</span>
          <span>{this.props.t('CANCEL_TICKET.RUT_PASSPORT_DNI')}</span>
          <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
            {this.props.t('CANCEL_TICKET.PRICE')}
          </span>
        </div>
        {Object.keys(ticketDetails.seat_Details.seat_details).map(key =>
          this.renderPassengerSeatRow(ticketDetails.seat_Details.seat_details[key], key),
        )}
      </div>
    );
  };

  renderPassengerSeatRow = (seat, key) => {
    return (
      <div className="right-card-sections font10" key={key}>
        <span>
          {seat.cancel_status === 0 ? (
            <KuposCheckbox
              onChange={() => this.props.onSeatCheck(key)}
              checked={this.props.selectedSeats[key]}
            />
          ) : null}
        </span>
        <span>{seat.seat_number}</span>
        <span>{seat.name}</span>
        <span>{seat.id_card_number}</span>
        <span style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {CommonService.currency(+seat.fare).split(',')[0]}
        </span>
      </div>
    );
  };

  render() {
    const { ticketDetails, t } = this.props;
    let isOfflineCancel =
      JSON.parse(sessionStorage.getItem('offlineCancel')) == true ? true : false;
    // const { t } = this.props;
    return (
      <div className="cancellation-passenger-details-block">
        <div className="passenger-details flex-row">
          <div className="cancel-bank-total-section">
            <div className="kupos-card bank-deposit-left-card font10">
              <div className="bank-deposit-heading font13">
                {t('CANCEL_TICKET.TICKET_DETAILS.NORMAL')}
                <span className="bold-text">{t('CANCEL_TICKET.TICKET_DETAILS.BOLD')}</span>
              </div>
              <div className=" flex-row pnr-number">
                <span className="bold-text">{t('CANCEL_TICKET.RESERVATION_NUMBER')}</span>
                <div className="kupos-button-secondary">{ticketDetails.pnr_number}</div>
              </div>

              <div className="city-name-box">
                <div className="city-name">
                  {/* <img src="/images/icons/home/icon_source2.png" alt="" />{' '} */}
                  <img
                    alt="Choose your origin city"
                    class="icon-size icon-left "
                    src="/images/search-bar/search-bar-origin.svg"
                  />
                  <span className="bold-text  font11">{ticketDetails.origin_name}</span>
                </div>

                <div className="city-name">
                  {/* <SvgHome name="pin" type="destination" /> */}
                  <img
                    alt="Choose your destination city"
                    class="icon-size icon-left "
                    src="/images/search-bar/search-bar-destination.svg"
                  />{' '}
                  <span className="bold-text  font11">{ticketDetails.destination_name}</span>
                </div>
              </div>

              <div className="datetime">
                <span className="bold-text ">{t('CANCEL_TICKET.TRAVEL_DATE')}:&nbsp;</span>
                {ticketDetails.travel_date
                  ? DateService.getDayNameFromDate(
                      ticketDetails.travel_date,
                      isOfflineCancel ? 'yyyy-mm-dd' : 'dd-mm-yyyy',
                    ) +
                    ', ' +
                    DateService.getDateFromDate(
                      ticketDetails.travel_date,
                      isOfflineCancel ? 'yyyy-mm-dd' : 'dd-mm-yyyy',
                    ) +
                    ' ' +
                    DateService.getMonthNameFromDate(
                      ticketDetails.travel_date,
                      isOfflineCancel ? 'yyyy-mm-dd' : 'dd-mm-yyyy',
                    ) +
                    ', ' +
                    DateService.getYearFromDate(
                      ticketDetails.travel_date,
                      isOfflineCancel ? 'yyyy-mm-dd' : 'dd-mm-yyyy',
                    )
                  : ''}
              </div>

              {ticketDetails.depart_time && (
                <div className="datetime">
                  <span className="bold-text "> {t('CANCEL_TICKET.DEPARTURE_TIME')}:&nbsp;</span>
                  {DateService.ampm(ticketDetails.depart_time)}
                </div>
              )}
            </div>

            <div className="kupos-button-secondary total-amount bold-text flex-row font12">
              <span>{t('CANCEL_TICKET.TOTAL_PRICE')}</span>{' '}
              <span className="text-right">
                CLP{' '}
                {
                  CommonService.currency(
                    +ticketDetails.total_net_amount || +ticketDetails.ticket_fare,
                  ).split(',')[0]
                }
              </span>
            </div>
          </div>

          <div className="kupos-card passenger-seat-details center-text">
            {this.props.isChangeTicket ? (
              <div className="bank-deposit-heading font13">
                {t('CANCEL_TICKET.WHICH_SEAT_YOU_WANT_TO_CHANGE.NORMAL')}
                <span className="bold-text">
                  {' '}
                  {t('CANCEL_TICKET.WHICH_SEAT_YOU_WANT_TO_CHANGE.BOLD')}
                </span>
              </div>
            ) : (
              <div className="bank-deposit-heading font13">
                {t('CANCEL_TICKET.WHICH_SEAT_YOU_WANT_TO_CANCEL.NORMAL')}
                <span className="bold-text">
                  {' '}
                  {t('CANCEL_TICKET.WHICH_SEAT_YOU_WANT_TO_CANCEL.BOLD')}
                </span>
              </div>
            )}

            {this.renderPassengerSeats()}

            <div className="accept-terms flex-row font10">
              <KuposCheckbox onChange={this.props.onTncChange} checked={this.props.tncChecked} />{' '}
              {this.props.isChangeTicket ? (
                <span
                  onClick={() => this.setState({ showReserveNumberOrTNCModel: true })}
                  className="cancel-notice-text"
                >
                  {t('CANCEL_TICKET.I_ACCEPT_TNC_CHANGE_TICKET')}
                </span>
              ) : (
                <span
                  onClick={() => this.setState({ showReserveNumberOrTNCModel: true })}
                  className="cancel-notice-text"
                >
                  {t('CANCEL_TICKET.I_ACCEPT_TNC')}
                </span>
              )}
            </div>
          </div>
        </div>

        <KuposModal
          ariaLabel="tnc-pnr-modal-outer"
          size={this.state.findPnrSelected ? 'lg' : 'xl'}
          onHide={() =>
            this.setState({ showReserveNumberOrTNCModel: false, findPnrSelected: false })
          }
          showModal={this.state.showReserveNumberOrTNCModel}
        >
          <div className="tnc-pnr-modal">
            {this.state.findPnrSelected ? (
              <img src="/images/find-reservation-no.png" />
            ) : (
              <TermsAndConditions t={this.props.t} />
            )}
            <div
              className="close-button pointer"
              onClick={() =>
                this.setState({ showReserveNumberOrTNCModel: false, findPnrSelected: false })
              }
            >
              <SvgHome name="close" />
            </div>
          </div>
        </KuposModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/cancellation/PassengerDetailsBlock.js